/* import ACTIONS from "../actions"; */

export default function invoicesReducer(state, action) {
  switch (action.type) {
    default: return state
  }

}